import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import Link from "../Link";
import Button from "@material-ui/core/Button";
import SubNav from "../SubNav";
import { useStaticQuery, graphql } from "gatsby";
import RobLogo from "../../images/rob-header-logo.png";
import SubNavDesktop from "../SubNavDesktop";
import styles from "./styles";
import { StaticImage } from "gatsby-plugin-image";

const useStyles = makeStyles((theme) => styles(theme));

export default function TopNav(props) {
  const [open, setOpen] = React.useState(false);
  const handleFullMenuOpen = () => {
    setOpen(!open);
  };
  const classes = useStyles();

  const data = useData();
  
  return (
    <React.Fragment>
      <SubNavDesktop />
      <div
        className={`top-nav  ${classes.topNav}  ${classes.topNavTheme}`}
        open={open}
      >
        <div className="site-logo">
          <Link to="/">
            <img
              className="desktop-logo"
              aria-label="Home"
              src={
                data.allWp.nodes[0].themeOptions.ThemeOptions.siteLogo.localFile
                  .publicURL
              }
              alt={data.allWp.nodes[0].locationData.LocationData.name || "Robinsons"}
              width={161}
              height={34}
            />
            <img
              className="mobile-logo"
              aria-label="Home"
              src={RobLogo}
              alt={data.allWp.nodes[0].locationData.LocationData.name || "Robinsons"}
              width={95}
              height={20}              
            />
          </Link>
        </div>
        <Button className="open-menu" onClick={handleFullMenuOpen}>
          Menu <span></span>
        </Button>
        <Toolbar component="nav" disableGutters={true}>
          {data.allWpMenu.nodes[0].menuItems.nodes.map((section) => (
            <Link
              key={section.path}
              to={section.path}
              className={section.cssClasses}
            >
              <span>{section.label}</span>
            </Link>
          ))}
        </Toolbar>
      </div>
      <div className={`full-nav  ${classes.fullNav}`} open={open}>
        <div className="overlay">
          <Button className="close-menu" onClick={handleFullMenuOpen}>
            Close <span></span>
          </Button>
          <div className="site-logo">
            <Link to="/">
              {/* TODO: make this a global class */}
              <span
                style={{
                  position: "absolute",
                  width: "1px",
                  height: "1px",
                  padding: "0",
                  margin: "-1px",
                  overflow: "hidden",
                  clip: "rect(0, 0, 0, 0)",
                  whiteSpace: "nowrap",
                  borderWidth: "0",
                }}
              >
                Home
              </span>
              <img
                className="desktop-logo"
                src={
                  data.allWp.nodes[0].themeOptions.ThemeOptions.siteLogo.localFile
                    .publicURL
                }
                alt="Logo"
              />
              <img className="mobile-logo" src={RobLogo} alt="Logo" />
            </Link>
          </div>
          <div className="nav-wrapper">
            <Toolbar
              className="main-nav-stacked"
              component="nav"
              disableGutters={true}
            >
              {data.allWpMenu.nodes[0].menuItems.nodes.map((section) => (
                <Link
                  className={section.cssClasses}
                  key={section.path}
                  to={section.path}
                >
                  {section.label}
                </Link>
              ))}
            </Toolbar>
            <SubNav />
          </div>
          <div className="house-data">
            <div className="rob-family mob">
              <Link to="https://www.robinsonsbrewery.com/">
                <StaticImage
                  src="../../images/rob-family-logo.png"
                  alt="Robinsons Family Brewers"
                />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

function useData() {
  const data = useStaticQuery(graphql`query TopNavItems {
    allWpMenu(filter: {locations: {eq: HEADER_MENU}}) {
      nodes {
        id
        name
        slug
        menuItems {
          nodes {
            id
            title
            url
            path
            label
            target
            order
            cssClasses
            childItems {
              nodes {
                id
                title
                url
                path
                label
                target
                order
              }
            }
          }
        }
      }
    }
    allWp {
      nodes {
      themeOptions {
        accommodationActive
        tableBookingActive
        ThemeOptions {
          siteLogo {
            localFile {
              id
              publicURL
              childImageSharp {
                gatsbyImageData(quality: 80, layout: FULL_WIDTH)
              }
            }
          }
          navBackgroundImage {
            localFile {
              id
              publicURL
              childImageSharp {
                gatsbyImageData(quality: 80, layout: FULL_WIDTH)
              }
            }
          }
          individualInnsBranding
        }
      }
      locationData {
        LocationData {
          address1
          address2
          email
          facebookHandle
          instagramHandle
          name
          postcode
          town
          twitterHandle
          telephone
          region
        }
      }
    }
  }
  }`);

  return data;
}
